module.exports = __webpack_public_path__ + "img/hand-scissors.8f6c1eee.svg";